import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useAuth } from "./usePasswordAuth";

const ProtectedRoutes = () => {
	const { isAuthenticated, loading } = useAuth();
	const location = useLocation();

	if (loading) return null;
	
	return isAuthenticated ? (
		<Outlet />
	) : (
		<Navigate to={`/password?redirect=${encodeURIComponent(location.pathname)}`} />
	);
};

export default ProtectedRoutes;
